import { get } from '../../utils/utils';
import { toItem } from './mappers/item';
import { eventsList } from '../../events/list';
import { createSocket } from '../../services/socket/createSocket';
import { TranscodingStatuses } from '../../constants/transcoding-statuses';
import { emit, emitResolve } from '../../events/notifier';
export function initSocket(settings, adapter, requestOptions) {
  var socketSettings = {
    messageUrl: settings.blackArrow.messageUrl,
    socketUrl: settings.blackArrow.wsUrl,
    tokenUrl: settings.apiUrl + settings.blackArrow.tokenUrl
  };
  var socket = createSocket(socketSettings, requestOptions);

  var emitItemUpdateEvent = function emitItemUpdateEvent(result) {
    var event = emit(adapter, eventsList.ITEM.UPDATE, {
      arguments: [result.data, result.data]
    });
    event.resolve(result);
  };

  socket.on('message', function (message) {
    if (message.type === 'status_update' && settings.asyncTranscoding) {
      if (get(message, 'file.op_status') === TranscodingStatuses.READY) {
        adapter.item.get(get(message, 'file.file_name')).then(emitItemUpdateEvent);
      } else {
        emitItemUpdateEvent({
          data: toItem(message.file, settings, {}, true)
        });
      }
    }

    if (message.type === 'trash_file') {
      emitResolve(adapter, eventsList.ITEMS.REMOVE, {
        arguments: [[message.file_name]]
      }, {
        data: {
          id: message.file_name
        }
      });
    }

    if (message.type === 'item_update') {
      var item = toItem(message.file, settings, {}, true);
      var event = emit(adapter, eventsList.ITEM.UPDATE, {
        arguments: [item, item]
      });
      event.resolve({
        data: item
      }); // uncomment when item_update implemented on server side

      /*
      emitResolve(adapter, eventsList.ITEM.UPDATE,
        {arguments: [[item, item]]},
        {data: item}
      );
      */
    }
  });
  return socket;
}